module.exports = __webpack_public_path__ + "img/facebook.10e34f16.svg";